import { navigate as navigateGatsby } from "gatsby";

const navigate = (
  to,
  { external = false, target = undefined, ...options } = {}
) => (external ? window.open(to, target) : navigateGatsby(to, options));

export { navigate };
